import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message

import ThemeDetailsUsageTrackerContext from '../../context/ThemeDetailsUsageTrackerContext';

const ThemeSetupGuideButton = (_ref) => {
  let {
    setupUrl
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["setupUrl"]);

  const {
    trackInteraction
  } = useContext(ThemeDetailsUsageTrackerContext);
  return /*#__PURE__*/_jsxs(UIButton, Object.assign({}, rest, {
    "data-hs-analytics-id": getThemeEventSelectorId('SETUP-GUIDE'),
    href: setupUrl,
    external: true,
    iconProps: {
      className: 'hidden'
    },
    onClick: () => trackInteraction('click setup guide link', {
      section: 'header'
    }),
    use: "link",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "lesson"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.setupGuide"
    })]
  }));
};

export default ThemeSetupGuideButton;